import QuoteStatusCard from './QuoteStatusCard'

export * from './QuoteStatusCard'
export default QuoteStatusCard
